import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck } from '@fortawesome/free-solid-svg-icons';

const ProgramBenefitCard = ({ 
  icon, 
  title, 
  description, 
  benefits = [],
  iconBgColor = 'bg-blue-500',
  iconColor = 'text-white'
}) => {
  return (
    <div className="bg-white rounded-lg shadow-md p-5 hover:shadow-lg transition-shadow duration-300 h-full">
      {/* Icon */}
      <div className={`w-14 h-14 ${iconBgColor} rounded-lg flex items-center justify-center mb-4`}>
        <FontAwesomeIcon icon={icon} className={`${iconColor} text-xl`} />
      </div>
      
      {/* Title */}
      <h3 className="text-lg font-bold text-gray-800 mb-3">{title}</h3>
      
      {/* Description */}
      <p className="text-gray-600 mb-4 leading-relaxed text-sm">{description}</p>
      
      {/* Benefits List */}
      {benefits.length > 0 && (
        <ul className="space-y-1.5">
          {benefits.map((benefit, index) => (
            <li key={index} className="flex items-start">
              <FontAwesomeIcon 
                icon={faCheck} 
                className="text-green-500 text-xs mt-1 mr-2 flex-shrink-0" 
              />
              <span className="text-gray-700 text-xs leading-relaxed">{benefit}</span>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

export default ProgramBenefitCard;
